module.exports = __webpack_public_path__ + "static/media/image5.78fcc718.jpeg";